function safeJsonParseMaybe(text) {
    const t = String(text ?? '').trim();
    if (!t) return { ok: false, value: null };
    const looksJson = (t.startsWith('{') && t.endsWith('}')) || (t.startsWith('[') && t.endsWith(']'));
    if (!looksJson) return { ok: false, value: null };
    try {
        return { ok: true, value: JSON.parse(t) };
    } catch {
        return { ok: false, value: null };
    }
}

export function normalizeCodeText(input) {
    if (!input) return '';
    let text = String(input).trim();

    // If backend sent escaped newline / tab characters, convert them first.
    text = text.replace(/\\r\\n/g, '\n');
    text = text.replace(/\\n/g, '\n');
    text = text.replace(/\\t/g, '  ');

    // Try JSON pretty print after newline normalization.
    try {
        const parsed = JSON.parse(text);
        return JSON.stringify(parsed, null, 2);
    } catch {
        return text;
    }
}

export function isCodeLikeChatMessage(body) {
    const raw = String(body ?? '');
    const t = raw.trim();
    if (!t) return false;

    // Fenced code is handled by markdown renderer.
    if (t.includes('```')) return false;

    // Heuristics for logs / stack traces.
    // Important: normal multi-line user messages can come back from backend with escaped newlines (\\n).
    // Do NOT classify "has \\n" as code-like by itself.
    const normalized = raw.replace(/\\r\\n/g, '\n').replace(/\\n/g, '\n');
    const looksLikeStack =
        /(^|\n)\s*at\s+\S+/m.test(normalized) ||
        /(Error|Exception)\b.*\n\s*at\s+/m.test(normalized) ||
        /processTicksAndRejections|node:internal\/process\/task_queues/.test(normalized);

    if (looksLikeStack) return true;

    // JSON-ish payloads (single or multi-line).
    const parsed = safeJsonParseMaybe(t);
    if (parsed.ok) return true;

    return false;
}

export function formatCodeLikeChatMessage(body) {
    return normalizeCodeText(body);
}
